module.exports = __webpack_public_path__ + "img/09-full.b1e26c0b.jpeg";